import { useState } from "react";

export const faqs = [
  {
    q: "Can I get an emergency passport for my MTSU study abroad program?",
    a: "Yes. We specialize in emergency passport processing for MTSU students with last-minute study abroad departures. If your program departure is within 2 weeks, call us immediately. We can often process passports within 48-72 hours for genuine study abroad emergencies.",
  },
  {
    q: "How do I renew my passport before my Nashville business trip abroad?",
    a: "If your trip is more than 6 weeks away, standard expedited processing is your best option. For trips within 2-3 weeks, we offer rush processing. Simply call us with your travel date and we'll recommend the right service tier.",
  },
  {
    q: "Do you handle family passport applications together?",
    a: "Yes! We specialize in family group applications. We coordinate all applications simultaneously to ensure every family member's passport is ready at the same time. Our family plan discounts make group applications more affordable.",
  },
  {
    q: "How far is Murfreesboro from the Atlanta Passport Agency?",
    a: "The Atlanta Passport Agency at 805 Broadway is approximately 35 miles north via I-24. With Nashville traffic, that round trip can easily take 3-4 hours. Our local Murfreesboro service eliminates that trip entirely.",
  },
  {
    q: "My passport was stolen in Murfreesboro — how quickly can I get a replacement?",
    a: "For stolen passport replacements, we handle the DS-64 declaration coordination and emergency replacement processing simultaneously. With proper documentation, we can have a replacement passport within 48-72 hours.",
  },
  {
    q: "Do you work with Nissan Smyrna employees needing business passports?",
    a: "Yes. We serve many Nissan Smyrna employees who travel to Japan and other international facilities. We understand corporate travel documentation requirements and can coordinate with HR teams for group processing.",
  },
  {
    q: "What documents do MTSU students need for a first-time passport?",
    a: "First-time applicants need: completed DS-11 form, U.S. birth certificate (original), government-issued photo ID (state driver's license), passport photo, and applicable fees. As a student, you can use your university enrollment documents for the application appointment. We review everything before submission.",
  },
];

export default function MurfreesboroFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Murfreesboro Passport Questions
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Answers to the most common passport questions from MTSU students, Rutherford County families, and Nashville metro professionals.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-start justify-between gap-4 p-6 text-left cursor-pointer"
              >
                <span className="font-semibold text-[#1A365D] text-base leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i
                    className={`ri-arrow-down-s-line text-[#1A365D] text-xl transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}